import { EActionType, EHttpCode } from '../data/Constants';
import { useAuth } from 'oidc-react';
import { t } from 'i18next';
import { FormLabel } from '@mui/material';

import type { IErrorMessageProps } from '../../types';

export const ErrorMessage = (props: IErrorMessageProps) => {
  const { error, manipulationType } = props;
  const auth = useAuth();

  let message = '';
  if (manipulationType) {
    message =
      manipulationType === EActionType.Create
        ? t('messages.fail.create')
        : t('messages.fail.update');
  }
  switch (error.code) {
    case EHttpCode.Status401:
      return (
        <span>
          {message + ' ' + t('messages.session')}
          <FormLabel
            className="formLabel-login-error"
            onClick={() => {
              auth.signIn();
            }}
          >
            {t('messages.login')}
          </FormLabel>
        </span>
      );
    case EHttpCode.Status204:
      return <span>{error.message ? error.message : message + ' ' + t('messages.error.204')}</span>;
    case EHttpCode.Status400:
      return (
        <span>
          {message + ' '} {error.message ? error.message : t('messages.error.400')}
        </span>
      );
    case EHttpCode.Status404:
      return <span>{error.message ? error.message : message + ' ' + t('messages.error.404')}</span>;
    case EHttpCode.Status403:
      return <span>{message + ' ' + t('messages.error.403')}</span>;
    default:
      return <span>{message + ' ' + t('messages.error.500')}</span>;
  }
};
